/**
 * Local constants for the Flow Planning Dashboard
 */

export enum TimePeriodInMinutes {
    FIFTEEN_MINUTES = '15',
    THIRTY_MINUTES = '30',
    FORTY_FIVE_MINUTES = '45',
    ONE_HOUR = '60',
}

export enum MonitoringEntityType {
    PROCESS_PATH = 'PROCESS_PATH',
}

export enum MetricName {
    UPH = 'UPH',
    VOLUME_PROCESSED = 'VOLUME_PROCESSED',
    HEADCOUNT = 'HEADCOUNT',
}

export enum ComparisonStatus {
    AHEAD = 'AHEAD',
    ON_TRACK = 'ON_TRACK',
    AT_RISK = 'AT_RISK',
    CRITICAL = 'CRITICAL',
}

export enum BaselineReferenceType {
    LATEST_SHIFT_PLAN = 'LATEST_SHIFT_PLAN',
}
